export default __webpack_public_path__ + "static/media/Snd_TryI.5f2ba411.mp3";